export default __webpack_public_path__ + "47c5f2f3c7c24f6f9294845fc025af93.png";